import { TextField, FormControl } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { SubmitButton } from '../../../../components';
import { changePasswordFirstLogin } from '../../../../service/CognitoAuthService';

export function ChangeFirstPassword({ tempData }) {
  const validationSchema = yup.object({
    password: yup
      .string('Enter your password')
      .min(8, 'Password should be of minimum 8 characters length')
      .required('Password is required'),
    confirmpassword: yup
      .string('Enter your password')
      .min(8, 'Password should be of minimum 8 characters length')
      .required('Password is required')
      .when('password', (password, schema) =>
        schema.test({
          test: (confirmpassword) => confirmpassword === password,
          message: "The passwords aren't equals",
        }),
      ),
  });
  const FirstLogin = async (value) => {
    try {
      const userAttributes = {
        family_name: tempData.userAttributes.family_name,
        given_name: tempData.userAttributes.given_name,
      };
      const response = await changePasswordFirstLogin(
        value.password,
        tempData.user,
        userAttributes,
      );
      return response;
    } catch (err) {
      return err;
    }
  };

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmpassword: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      const responseFirstLogin = await FirstLogin(values);
    },
  });

  return (
    <FormControl style={{ width: '100%' }} onClick={formik.handleSubmit}>
      <TextField
        style={{ marginTop: '5px' }}
        fullWidth
        id="password"
        name="password"
        label="Password"
        type="password"
        value={formik.values.password}
        onChange={formik.handleChange}
        error={formik.touched.password && Boolean(formik.errors.password)}
        helperText={formik.touched.password && formik.errors.password}
      />

      <TextField
        style={{ marginTop: '5px' }}
        fullWidth
        id="confirmpassword"
        name="confirmpassword"
        label="Confirm Password"
        type="password"
        value={formik.values.confirmpassword}
        onChange={formik.handleChange}
        error={formik.touched.confirmpassword && Boolean(formik.errors.confirmpassword)}
        helperText={formik.touched.confirmpassword && formik.errors.confirmpassword}
      />
      <SubmitButton className="button-black">Change Password</SubmitButton>
    </FormControl>
  );
}

ChangeFirstPassword.propTypes = {
  tempData: PropTypes.node.isRequired,
};
